/**
 * Simple sliding window rate limiter for client-side throttling.
 */
class RateLimiter {
    private requests: number[] = [];
    private readonly maxRequests: number;
    private readonly windowMs: number;

    constructor(maxRequests: number, windowMs: number) {
        this.maxRequests = maxRequests;
        this.windowMs = windowMs;
    }

    /**
     * Checks if a request is allowed.
     * @returns true if allowed, false if throttled
     */
    allow(): boolean {
        const now = Date.now();
        // Remove expired timestamps
        this.requests = this.requests.filter((timestamp) => now - timestamp < this.windowMs);

        if (this.requests.length < this.maxRequests) {
            this.requests.push(now);
            return true;
        }

        return false;
    }

    getRemainingWaitMs(): number {
        if (this.requests.length === 0) return 0;
        const now = Date.now();
        const oldest = this.requests[0];
        return Math.max(0, this.windowMs - (now - oldest));
    }
}

// Allow 200 requests every 10 seconds (accommodates high concurrency of complex dashboards loading parallel widgets)
export const globalRateLimiter = new RateLimiter(200, 10000);
